<template>
  <div class="">
    <div class="">
      <petty-cash-certificate-form-box
        :form-type="formType"
        :isSubmission="isSubmission"
        @add="onAdd"
        @edit="onEdit"
        @approve="handleApprove"
        @reject="handleReject"
      ></petty-cash-certificate-form-box>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import router from '@/router';
import PettyCashCertificateFormBox from '@/components/PettyCash/Certificate/PettyCashCertificateFormBox.vue';

export default {
  name: 'PettyCashCertificateForm',
  components: {
    PettyCashCertificateFormBox
  },
  data() {
    return {
      formType: '',
      id: null,
      isSubmission: false,
      isSsmSubmitted: false
    };
  },
  mounted() {
    if (this.$route.name === 'cash-certificate-form-new') {
      this.formType = 'new';
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;
    }
    if (this.user && this.user.roles) {
      this.user.roles.map(item => {
        if (item.name === 'FINANCE_ADMIN') {
          this.isFinanceAdmin = true;
        }
        if (item.name === 'ACCOUNTANT') {
          this.isAccountant = true;
        }
        if (item.name === 'STORE_SALES_MANAGER') {
          this.isSsm = true;
        }
      });
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('pettyCash', ['postCashCertificate', 'patchCashCertificate']),
    onAdd(formData) {
      this.postCashCertificate({
        cashCertificate: formData,
        router,
        redirectUrl: '/petty-cash/certificate'
      });
    },
    onEdit(cashCertificate) {
      this.patchCashCertificate({
        id: this.id,
        newCashCertificate: cashCertificate,
        router: router,
        redirectUrl: '/petty-cash/certificate'
      });
    },
    handleApprove({ row }) {
      this.patchCashCertificate({
        id: this.id,
        newCashCertificate: row,
        router: router,
        redirectUrl: '/petty-cash/certificate'
      });
      this.isSubmission = true;
    },
    handleReject({ row }) {
      this.patchCashCertificate({
        id: this.id,
        newCashCertificate: row,
        router: router,
        redirectUrl: '/petty-cash/certificate'
      });
      this.isSubmission = true;
    }
  }
};
</script>
